import AIEntityInstruction from 'models/aiEntityInstruction';
import AIEntityInstructionDTO from 'models/dto/aiEntityInstructionDTO';
import { EntityTypes } from 'models/entity';

export function mapFromAIEntityInstruction(dto: AIEntityInstructionDTO): AIEntityInstruction {
  const instruction = new AIEntityInstruction();
  instruction.tenantId = dto.tenantId ?? '';
  instruction.isoNormId = dto.isoNormId ?? 0;
  instruction.entityType = dto.entityType ?? EntityTypes.Link;
  instruction.code = dto.code ?? '';
  instruction.instruction = dto.instruction ?? '';

  return instruction;
}

export function mapToAIEntityInstruction(instruction: AIEntityInstruction): AIEntityInstructionDTO {
  const dto = new AIEntityInstructionDTO();
  dto.tenantId = instruction.tenantId;
  dto.isoNormId = instruction.isoNormId;
  dto.entityType = instruction.entityType;
  dto.code = instruction.code;
  dto.instruction = instruction.instruction;

  return dto;
}
